import React from 'react';

type BadgeVariant = 'positive' | 'negative' | 'warning' | 'info' | 'neutral' | 'wildlife' | 'distress' | 'equipment' | 'ice';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
  dot?: boolean;
}

const variantClasses: Record<BadgeVariant, string> = {
  positive: 'bg-positive/10 text-positive border-positive/20',
  negative: 'bg-negative/10 text-negative border-negative/20',
  warning: 'bg-warning/10 text-warning border-warning/20',
  info: 'bg-primary/10 text-primary border-primary/20',
  neutral: 'bg-muted text-muted-foreground border-border',
  wildlife: 'bg-[#264653]/30 text-[#4CC9F0] border-[#264653]/50',
  distress: 'bg-negative/15 text-negative border-negative/30',
  equipment: 'bg-warning/10 text-warning border-warning/20',
  ice: 'bg-accent/10 text-accent border-accent/20',
};

export default function Badge({ variant = 'neutral', children, className = '', dot = false }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold border tracking-wide ${variantClasses[variant]} ${className}`}
    >
      {dot && (
        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${
          variant === 'positive' ? 'bg-positive status-dot-active' :
          variant === 'negative' ? 'bg-negative status-dot-active' :
          variant === 'warning'? 'bg-warning' : 'bg-primary'
        }`} />
      )}
      {children}
    </span>
  );
}